module.exports = __webpack_public_path__ + "img/logo.a999c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 243
// module chunks = 1